const {Backbone} = require('backboneAdapter');
import NavBarView from 'js/views/navbar.view';
import CreditsSpentView from 'js/views/credits.spent.view';
import CreditsSpentBundlesView from 'js/views/credits.spent.bundles.view';
import CreditsHistoryView from 'js/views/credits.history.view';
import CreditsBuyView from 'js/views/credits.buy.view';
import CreditsEmailReservedView from 'js/views/credits.email.reserved.view';
require('metroHelpers');

$.ajaxSetup({
    error: function (jqXHR) {
        $.Notify.error('Error ' + jqXHR.status);
    }
});
export default Backbone.Router.extend({
    routes: {
        "": "defaultRoute"
    },
    initialize: function () {
        this.navbar = new NavBarView();
        this.creditsSpent = new CreditsSpentView();
        this.creditsSpentBundles = new CreditsSpentBundlesView();
        this.creditsHistory = new CreditsHistoryView();
        this.creditsBuy = new CreditsBuyView();
        this.creditsEmailReservedView = new CreditsEmailReservedView();
    },
    defaultRoute: function () {
        console.info("creditRoute");
    }
});
